import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Hamburger from 'react-hamburgers';

import AppMobileMenu from '../AppMobileMenu';

import { setEnableClosedSidebar } from '@reducer/ThemeOptions';

import { useHistory } from 'react-router-dom';

const HeaderLogo = props => {
    const history = useHistory();
    const dispatch = useDispatch();
    const { enableClosedSidebar } = useSelector(state => state.ThemeOptions);
    const [active, setActive] = useState(false);

    const toggleActive = () => {
        setActive(!active);
    };

    const toggleEnableClosedSidebar = () => {
        dispatch(setEnableClosedSidebar(!enableClosedSidebar));
    };

    const toHome = () => {
        history.push('/');
    };

    return (
        <>
            <div className="app-header__logo">
                <div className="logo-src cursor-pointer" onClick={toHome}>
                    IndoorPlus+
                </div>
                <div className="header__pane ml-auto">
                    <div onClick={toggleEnableClosedSidebar}>
                        <Hamburger active={enableClosedSidebar} type="elastic" onClick={toggleActive} />
                    </div>
                </div>
            </div>
            <AppMobileMenu />
        </>
    );
};

export default HeaderLogo;
